import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import get from 'lodash/get';

import getNamespacedFieldName from './getNamespacedFieldName';

// Returns true if at least one field has been filled in
const useFormikAreSomeFieldsFilled = (fieldNamesArray = [], namespace) => {
  // const { initialValues, values } = useFormikContext();
  const { values } = useFormikContext();

  return useMemo(() => {
    if (!Array.isArray(fieldNamesArray)) {
      console.error(
        `You must provide an array of field names. You provided "${String(
          JSON.stringify(fieldNamesArray)
        )}"`
      );
      return false;
    }
    return fieldNamesArray.reduce((areSomeOfPreviousFilledIn, rawName) => {
      const fieldName = getNamespacedFieldName(rawName, namespace);
      return (
        areSomeOfPreviousFilledIn ||
        // Used to check if different than initialValues to determine if open
        // get(values, fieldName) !== get(initialValues, fieldName)
        // Now we only check if the value set is not falsish, so we can set initialValues
        // with data that was persisted.
        !!get(values, fieldName)
      );
    }, false);
  }, [fieldNamesArray, values, namespace]);
};
export default useFormikAreSomeFieldsFilled;
